import { usePage } from "@inertiajs/react"
import { UserLayout } from "@/components/layouts/user-layout"
import { MenuScreen } from "@/features/user/menu-screen"
import type { DinerSummary, MenuPayload } from "@/features/user/types"

type Props = {
  diner: DinerSummary
  menu: MenuPayload
}

export default function UserMenusShow() {
  const { diner, menu } = usePage<Props>().props

  return (
    <UserLayout wide>
      <MenuScreen diner={diner} menu={menu} />
    </UserLayout>
  )
}
